import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'issys-loader',
  templateUrl: './issys-loader.component.html',
  styleUrls: ['./issys-loader.component.scss'],
})
export class IssysLoaderComponent implements OnInit {
  @Input() mensaje :String="Aguarde..."
  @Input() label :String=""
  @Input() stop = false

  constructor() { }

  ngOnInit() { }
  ngOnChanges() {  }
}
